import model from '../../prototypes/VALUE_BOOLEAN';
import './pt-relay-intersection.css';

export default {
	model
};
